import React from 'react';

import { TrendingSearch, TrendingSearchCta } from 'types';
import { dataEmIncludingSpaceCleanUpFunction } from 'utility/common-utils';
import './TrendingSearches.scss';
import { checkStores } from 'utility/utility';
import Chip from './Chip/Chip';

interface TrendingSearchesProps {
  content: TrendingSearch;
}

const TrendingSearches = ({ content }: TrendingSearchesProps) => {
  if (!content) {
    return null;
  }

  return (
    <div
      data-testid="TrendingSearches"
      className="trending-searches-container hmf-display-flex hmf-justify-content-left hmf-justify-content-xlg-center">
      <section
        className="trending-searches hmf-display-flex hmf-align-items-center hmf-px-s hmf-pb-xs hmf-px-md-m"
        id="trendingSearchBar">
        {content.headline && (
          <p
            className="headline hmf-display-none hmf-display-xlg-flex hmf-body-bold-m hmf-pl-s hmf-mr-m hmf-m-0"
            {...(content.headlineFontColor && { style: { color: content.headlineFontColor } })}>
            {content.headline}
          </p>
        )}
        {content.cta && (
          <div className="chip-container hmf-flex-no-wrap hmf-display-flex hmf-lg-flex-wrap">
            {content.cta.map((trendingSearch: TrendingSearchCta) => {
              const dataEm = `trendingSearch_home_${dataEmIncludingSpaceCleanUpFunction(
                trendingSearch.linkTitle,
              )}`;
              return (
                <Chip
                  key={JSON.stringify(trendingSearch)}
                  href={checkStores(trendingSearch?.link ?? '')}
                  label={trendingSearch.linkTitle}
                  dataEm={dataEm}
                  backgroundColor={content.chipBackgroundColor}
                  fontColor={content.chipFontColor}
                />
              );
            })}
          </div>
        )}
      </section>
    </div>
  );
};

export default TrendingSearches;
